import {
  PRESENTATION_INIT_DATA, 
  SLIDE_DATA, 
  SLIDE_PREVIEW, 
  PPTS_OPEN,
  SELECTED_PPT, 
  PPTS_CLOUD, 
  SESSION_CODE, 
  USER_COUNT, 
  SLIDE_STATIC_DATA,
  TITLE_BAR, 
  SLIDE_INDEX, 
  FULLSCREEN, 
  STATE_LOADING_PRESENTATION, 
  LANGUAGE,
  ORIENTATION, 
  KEYBOARD, 
  CONFIG_SHARE,
  OPEN_MODAL,
  CLOSE_MODAL,
  CLOSE_CONFIG,
  OPEN_CONFIG,
  PRESENTATION_MODE_CONFIG,
  SUBMENU_CONFIG,
  HOTPLUGIN_INFO,
  SET_AUDITORIUM_MODE,
} from './constants';

export const setDataPresentation = ( name, user ) => ({
    type: PRESENTATION_INIT_DATA, 
    name: name, 
    user: user
});

export const setSlideInfo = ( dataSession ) => ({  
  	type: SLIDE_DATA, 
    data: dataSession,
});

export const setStaticSlideInfo = ( dataSession ) => ({
  	type: SLIDE_STATIC_DATA, 
    data: dataSession,
});

export const setSlidePreview = ( previewUrl ) => ({
    type: SLIDE_PREVIEW, 
    data: { previewUrl:previewUrl } 
});

export const setPPTsOpen = ( ppts ) => ({
    type: PPTS_OPEN, 
    data: ppts,
});

export const setSelectedPPT = ( name, isCloud ) => ({
    type: SELECTED_PPT, 
    name: name, 
    isCloud: isCloud
});

export const setPPTsCloud = ( ppts ) => ({
    type: PPTS_CLOUD, 
    data: ppts,
});

export const setSessionCode = ( code ) => ({
    type: SESSION_CODE, 
    data: code,
});

export const setAmountConnections = ( amount ) => ({
    type: USER_COUNT, 
    data: amount,
});

export const setTitleBar = ( title, showMenu ) => ({
    type: TITLE_BAR, 
    title: title, 
    showMenu: showMenu
});

export const setSlideIndex = ( index ) => ({
    type: SLIDE_INDEX, 
    data: index,
});

export const setFullScreen = ( isFullScreen ) => ({
    type: FULLSCREEN, 
    data: isFullScreen
});

export const setStateLoadingPresentation = ( state ) => ({
    type: STATE_LOADING_PRESENTATION, 
    data: state
});

export const setLanguage = ( data ) => ({
    type: LANGUAGE, 
    data: data
});

export const setOrientation = ( data ) => ({
    type: ORIENTATION, 
    data: data
});

export const setKeyboard = ( visible ) => ({
    type: KEYBOARD, 
    data: visible
});

export const setSharePPT = ( config ) => ({
    type: CONFIG_SHARE, 
    config: config
});

export const openModalWindow = ( modalWindow ) => ({
  type: OPEN_MODAL,
  modalWindow: modalWindow
});

export const closeModalWindow = () => ({
  type: CLOSE_MODAL,  
});

export const closeConfig = () => ({
  type: CLOSE_CONFIG,  
});

export const openConfig = () => ({
  type: OPEN_CONFIG,  
});

export const setPresentationModeConfig = (config, data) => ({
  type: PRESENTATION_MODE_CONFIG,  
  config: config,
  data: data,
});

export const setSubmenuInfo = (subMenus) => ({
  type: SUBMENU_CONFIG,    
  subMenus: subMenus,
});

export const setHotPluginInfo = (data) => ({
  type: HOTPLUGIN_INFO,    
  data: data,
});

export const setAuditoriumMode = ( value ) => ({
  type: SET_AUDITORIUM_MODE,    
  isAuditoriumMode: value,

});


// WEBPACK FOOTER //
// ./src/containers/App/actions.js